import React, { useEffect } from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import Footer from "../footer/Footer";
import Header from "../header/Header";
const Layout = (props) => {
  return (
    <React.Fragment>
      <div className="d-flex flex-column flex-root">
        <div className="page d-flex flex-row flex-column-fluid">
          <div
            id="kt_aside"
            className="aside mobile-nav"
            data-kt-drawer="true"
            data-kt-drawer-name="aside"
            data-kt-drawer-activate="{default: true, lg: false}"
            data-kt-drawer-overlay="true"
            data-kt-drawer-width="{default:'200px', '300px': '250px'}"
            data-kt-drawer-direction="start"
            data-kt-drawer-toggle="#kt_aside_mobile_toggle"
          >
            <Sidebar page={props.page} />
          </div>
          <div
            className="wrapper d-flex flex-column flex-row-fluid"
            id="kt_wrapper"
          >
            <Header title={props.title} />
            {props.children}
          </div>
        </div>
        <div className="footer py-4 d-flex flex-lg-column" id="kt_footer">
          <Footer />
        </div>
      </div>
    </React.Fragment>
  );
};

export default Layout;
